import { getUsageDetailOptions } from "@/modules/DailyQuota/queries/getUsageDetails";
import { useQuery } from "@tanstack/react-query";
import { startTransition, useEffect, useState } from "react";

const useAuth = () => {
    const { data } = useQuery(getUsageDetailOptions());
    const [isMounted, setIsMounted] = useState(data?.data?.isRegistered || false);

    const isLoggedIn = () => {
        if (typeof window === "undefined") return false;
        const token = localStorage.getItem("token");
        return !!token;
    };
    const setToken = (token: string) => {
        if (typeof window !== "undefined") {
            localStorage.setItem("token", token);
        }
    };
    const logout = () => {
        if (typeof window !== "undefined") {
            localStorage.removeItem("token");
            localStorage.removeItem("email");
        }
    };
    const setUserEmail = (email: string) => {
        if (typeof window !== "undefined") {
            localStorage.setItem("email", email);
        }
    };
    const getUserEmail = (): string | null => {
        if (typeof window !== "undefined") {
            return localStorage.getItem("email");
        }
        return null;
    };

    useEffect(() => {
        startTransition(() => {
            setIsMounted(true);
        });
    }, []);

    return { isLoggedIn, isMounted, setToken, logout, setUserEmail, getUserEmail };
};
export default useAuth;
